<template>
  <v-container fluid >
    <v-form @submit="updateStudyGroup">
      <v-card v-if="study_group">
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field label="Name"
                            v-model="study_group.name"
                            color="secondary"
                            type="text"
                            validate-on-blur
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Short Name"
                            v-model="study_group.short_name"
                            color="secondary"
                            type="text"
                            validate-on-blur
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>

        <v-card-subtitle class="box-shadow">Dates for recruitment of candidates for the group</v-card-subtitle>
        <v-divider/>
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" md="6" class="my-0">
              <date-field label=""
                          v-model="study_group.recruitment_period[0]"
                          :error-messages="api_errors['recruitment_period']"
              />
            </v-col>
            <v-col cols="12" md="6" class="my-0">
              <date-field label=""
                          v-model="study_group.recruitment_period[1]"
                          :error-messages="api_errors['recruitment_period']"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider/>
        <v-card-subtitle class="box-shadow">Study period</v-card-subtitle>
        <v-divider/>
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" md="6" class="my-0">
              <date-field label=""
                          v-model="study_group.study_period[0]"
                          :error-messages="api_errors['study_period']"
              />
            </v-col>
            <v-col cols="12" md="6" class="my-0">
              <date-field label=""
                          v-model="study_group.study_period[1]"
                          :error-messages="api_errors['study_period']"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider/>
        <v-card-subtitle class="box-shadow">Visits filtering end</v-card-subtitle>
        <v-divider/>
        <v-card-text class="py-0">
          <date-field
              v-model="study_group.visits_filtering_end"
              :error-messages="api_errors['visits_filtering_end']"
          />
        </v-card-text>

        <v-divider/>
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-switch label="Members only"
                        v-model="study_group.members_only"
                        false-value="0"
                        :error-messages="api_errors['members_only']"/>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-switch label="Members auto-approve"
                        v-model="study_group.members_auto_approve"
                        false-value="0"
                        :error-messages="api_errors['members_auto_approve']"/>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider/>
        <v-card-subtitle class="box-shadow">Booking Policy</v-card-subtitle>
        <vue-editor id="study_group_booking_policy" v-model="study_group.booking_policy" :editor-toolbar="toolbar"></vue-editor>

        <v-divider/>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" @click="$router.back()">Back</v-btn>
          <v-btn color="success" type="submit">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    study_group: null,
    toolbar: [
      [
        { header: [false, 1, 2, 3, 4, 5, 6] },
        "bold", "italic", "underline"
      ],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
      ],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["link", "formula"],
    ],
    api_errors: []
  }),
  mounted() {
    this.study_group = {
      name: '',
      short_name: '',
      recruitment_period: ['', ''],
      study_period: ['', ''],
      visits_filtering_end: '',
      booking_policy: '',
      members_only: true,
      members_auto_approve: false,
    }
    this.api_errors = []
  },
  methods: {
    updateStudyGroup(e) {
      e.preventDefault()
      this.app_loading = true
      this.api_errors = []
      this.axios.post(`api/study-groups`, this.study_group)
          .then(({data}) => {
            this.$notify('Success!', 'success')
            this.$router.push({name: 'Study group', params: {study_group_id: data.data.id}})
          })
        .catch(errors => {this.api_errors = errors.response.data.errors})
        .then(() => {this.app_loading = false})
    }
  }

}
</script>